import styled from 'styled-components';
import Colors from '@/constants/Colors';

export const StyledInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .input-label {
    padding: 0 0 8px;
    line-height: 1.5715;

    &.required::before {
      color: ${Colors.red};
      content: '*';
      color: ${Colors.red};
      display: inline-block;
      margin-right: 4px;
      font-size: 14px;
      font-family: sans-serif;
    }
  }

  .wrapped-input {
    width: 100%;
    /* &.has-error > * {
      border: 1px solid ${Colors.red};
      border-radius: 3px;
    } */
    & > * {
      width: 100%;
    }
  }

  .input-explain {
    min-height: 24px;
    color: ${Colors.gray};
    &.has-error {
      color: ${Colors.red};
    }
  }
`;
